// Third party and libarries
import React, { useEffect, useState } from 'react'
import { Card, Container, Tabs, Tab, Navbar } from 'react-bootstrap';
import useReactRouter from "use-react-router";
import { useLazyQuery } from '@apollo/client';

// components
import "../../styles/checkoutStyle.css"
import StepOrderDetail from './StepOrderDetail';
import StepAddAddress from './StepAddAddress';
import StepPayment from './StepPayment';
import StepComplted from './StepComplted';
import LoadingSpinner from '../../components/LoadingSpinner';

// constant
import logoLogin from "../../image/logo_main.png";
import { GET_EXCHANGRATE } from '../../graphql/exchangeRate/Query';
import useWindowDimensions from '../../helpers/useWindowDimensions';
import { COLOR_APP, COLOR_WHITE, S3_URL } from '../../constants';
import { GET_ORDERGROUPS_DETAIL } from '../../graphql/order/query';

// icons 
import { FaCheckCircle, FaMapMarkedAlt, FaSitemap } from 'react-icons/fa';
import { MdPayment } from 'react-icons/md';


export default function ConfirmFillsForm() {
    const { height, width } = useWindowDimensions();
    const { history, match, location } = useReactRouter();

    // State
    const [activeTab, setActiveTab] = useState("order-detail");
    const [orderGroupData, setOrderGroupData] = useState()
    const [shopRate, setShopRate] = useState()
    const [prepareDatas, setPrepareDatas] = useState({})

    // appolo client
    const [getOrderGroupById, { data: loadOrderGroup, loading: loadingOrderGroup }] = useLazyQuery(GET_ORDERGROUPS_DETAIL, { fetchPolicy: 'cache-and-network' })
    const [getExchangeRate, { data: loadExchangeRate, loading: loadingExchange }] = useLazyQuery(GET_EXCHANGRATE, { fetchPolicy: "cache-and-network" });

    // useEffect 
    useEffect(() => {

        if (match?.params?.data) {
            let orderId = match?.params?.data;
            fetchOrderGroupDatas(orderId)
        }

    }, [match?.params?.data])

    useEffect(() => {

        if (loadExchangeRate) {
            setShopRate(loadExchangeRate?.exchangeRate)
        }

    }, [loadExchangeRate])

    // useEffect 
    useEffect(() => {

        if (loadOrderGroup?.orderGroup) {

            setOrderGroupData(loadOrderGroup?.orderGroup)
            fetchRateForShop(loadOrderGroup?.orderGroup?.shop?.id)
        }

    }, [loadOrderGroup])

    console.log("prepareDatas:", prepareDatas)


    // feact order group datas
    const fetchOrderGroupDatas = async (_id) => {
        try {
            await getOrderGroupById({
                variables: {
                    where: {
                        id: _id,
                        // type: "LIVE"
                    },
                    orderBy: "createdAt_DESC",
                },
            })
        } catch (error) {
            console.log({ error })
        }
    }

    // fetch exchange rate for shop
    const fetchRateForShop = (shopId) => {
        if (loadingExchange) return;
        getExchangeRate({
            variables: {
                where: {
                    shop: shopId,
                },
            },
        });
    }

    if (loadingOrderGroup && !loadOrderGroup) return <LoadingSpinner />

    return (
        <React.Fragment>
            <Navbar fixed="top" style={{ background: COLOR_APP, color: COLOR_WHITE }} className='d-flex gap-2'>
                <img src={logoLogin} alt='brand-logo' style={{ maxWidth: 46, borderRadius: '50em' }} />
                <div className='d-flex gap-2 justify-content-center align-items-center'>
                    <img src={S3_URL + orderGroupData?.shop?.image} alt='shop-profile' style={{ maxWidth: 46, borderRadius: '50em' }} />
                    <h4>{orderGroupData?.shop?.name}</h4>
                </div>
            </Navbar>

            <Container id="customer-fills-form" fluid={width > 700 ? false : true} style={{ display: 'flex', justifyContent: 'center', alignItems: 'start', flexDirection: 'column', padding: 3 }} >

                <Card style={{ width: '100%', boxShadow: 'none', padding: 0, border: 'none' }}>
                    <Card.Body style={{ padding: width > 700 ? 10 : 1, marginTop: "4em", minHeight: '70vh' }}>
                        <Tabs
                            activeKey={activeTab}
                            onSelect={(key) => setActiveTab(key)}
                            id="custom-tabs-example" className="mb-3 custom-tab" fill
                        >
                            <Tab eventKey="order-detail" title={stepOrder()}>
                                <StepOrderDetail setActiveTab={setActiveTab} orderGroupData={orderGroupData} shopRate={shopRate} />
                            </Tab>
                            <Tab eventKey="add-address" title={stepAddress()}>
                                <StepAddAddress setActiveTab={setActiveTab} orderGroupData={orderGroupData} setPrepareDatas={setPrepareDatas} />
                            </Tab>
                            <Tab eventKey="payment-order" title={stepPayment()}>
                                <StepPayment orderGroupData={orderGroupData} />
                            </Tab>
                            <Tab eventKey="completed" title={stepCompleted()}>
                                <StepComplted />
                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>
            </Container>
        </React.Fragment>

    )
}

const stepOrder = () => (
    <div className='d-flex justify-content-center align-items-center'>
        <FaSitemap />
        <span>ອໍເດີ້</span>
    </div>)

const stepAddress = () => (
    <div className='d-flex justify-content-center align-items-center'>
        <FaMapMarkedAlt />
        <span>ເພິ່ມທີ່ຢູ່ເພື່ອຈັດສົ່ງ</span>
    </div>)

const stepPayment = () => (
    <div className='d-flex justify-content-center align-items-center'>
        <MdPayment />
        <span>ຊຳລະເງິນ</span>
    </div>)

const stepCompleted = () => (
    <div className='d-flex justify-content-center align-items-center'>
        <FaCheckCircle />
        <span>ສຳເລັດ</span>
    </div>)
